// extracted by mini-css-extract-plugin
export default {"nameinput":"classroomStep_nameinput__dpb-V"};